// Implement robust environment variable handling
const getEnvVar = (name, defaultValue = '') => {
  // Cache for consistent access
  if (!window.__ENV_VARS__) {
    window.__ENV_VARS__ = {};
  }

  // Return cached value if it exists
  if (window.__ENV_VARS__[name] !== undefined) {
    return window.__ENV_VARS__[name];
  }

  // Multiple fallback options
  let value;

  // Try process.env first (for development environment)
  if (typeof process !== 'undefined' && process.env && process.env[name] !== undefined) {
    value = process.env[name];
    console.log(`Using process.env for ${name}`);
  }
  // Try window.ENV (sometimes used in production deployments)
  else if (window.ENV && window.ENV[name] !== undefined) {
    value = window.ENV[name];
    console.log(`Using window.ENV for ${name}`);
  }
  // Try direct window variables (sometimes used in certain deployments)
  else if (window[name] !== undefined) {
    value = window[name];
    console.log(`Using window variable for ${name}`);
  }
  // Use default value as final fallback
  else {
    value = defaultValue;
    console.log(`Using default value for ${name}: ${defaultValue}`);
  }

  // Cache for future use
  window.__ENV_VARS__[name] = value;
  return value;
};

export const apiUrl = `${getEnvVar('REACT_APP_API_HOST', 'https://dpowt31ebk.execute-api.us-east-1.amazonaws.com')}/api/`;
export const BillsbyUrl = `${getEnvVar('REACT_APP_API_HOST', 'https://dpowt31ebk.execute-api.us-east-1.amazonaws.com')}/billsby`;
export const NffsUrl = `${getEnvVar('REACT_APP_API_HOST', 'https://dpowt31ebk.execute-api.us-east-1.amazonaws.com')}/nffs`;
export const AssociationUrl = `${getEnvVar('REACT_APP_API_HOST', 'https://dpowt31ebk.execute-api.us-east-1.amazonaws.com')}/association`;
export const RestURL = `${getEnvVar('REACT_APP_API_HOST', 'https://dpowt31ebk.execute-api.us-east-1.amazonaws.com')}/`;
export const tomcatHost = `${getEnvVar('REACT_APP_TOMCAT_HOST', '')}`;
export const tomcatHostUpload = `${getEnvVar('REACT_APP_TOMCAT_HOST_UPLOAD', '')}`;
export const cloudFrontCdnUrl = `${getEnvVar('REACT_APP_CLOUDFRONT_CDN_URL', '')}`;
export const s3SupportDocs = `${getEnvVar('REACT_APP_S3_SUPPORT_DOCS', '')}`;

// ACE login URLs - prod vs stage
// Prod: valorgroup-securesignon.my.site.com
// Stage/Dev: valorgroup-securesignon--iconsandb.sandbox.my.site.com
export const aceLoginUrl = getEnvVar(
  'REACT_APP_ACE_LOGIN_URL',
  'https://valorgroup-securesignon--iconsandb.sandbox.my.site.com/ACE/login?ec=302&startURL=%2FACE%2F'
);

// Pagination
export const DEFAULT_PAGINATION_SIZE = 20;

// Dates
export const DEFAULT_UI_DATE_FORMAT = 'MM-dd-yy';
export const DEFAULT_DB_DATE_FORMAT = 'yyyy-MM-dd';

console.log(getEnvVar('REACT_APP_S3_SUPPORT_DOCS', ''), "staging");

// Log environment configuration for testing
console.log('=== ENVIRONMENT CONFIGURATION TEST ===');
console.log('AUTH0_NAMESPACE:', getEnvVar('REACT_APP_AUTH0_NAMESPACE'));
console.log('TOMCAT_HOST:', getEnvVar('REACT_APP_TOMCAT_HOST'));
console.log('TOMCAT_HOST_UPLOAD:', getEnvVar('REACT_APP_TOMCAT_HOST_UPLOAD'));
console.log('=====================================');


// WEBPACK FOOTER //
// ./src/config/properties.js